const DIRTY_KEY = 'valenpos:expenses:dirty:v1';

export const markExpensesCacheDirty = (reason = 'mutation') => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(DIRTY_KEY, JSON.stringify({ ts: Date.now(), reason }));
  } catch {}
};

export const getExpensesDirtyMarker = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(DIRTY_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && Number.isFinite(Number(parsed.ts)) ? parsed : null;
  } catch {
    return null;
  }
};

export { DIRTY_KEY as EXPENSES_DIRTY_KEY };
